import { Component } from 'react'
import { AutoSizer } from 'react-virtualized'
import { ConditionalWrap } from 'beam/dist/utils'
import PlayerPiano from '../../PlayerPiano/PlayerPiano'
import PropTypes from 'prop-types'
import AudioEnergyTape from './AudioEnergyTape'
import withStyles from 'beam/dist/styles'
import { PANEL_SIZES } from '../../MediaPlayer/helpers'

class AudioEnergy extends Component {
  static propTypes = {
    theme: PropTypes.object.isRequired,
    callDurationMs: PropTypes.number.isRequired,
    audioDurationMs: PropTypes.number.isRequired,
    audioOffsetMs: PropTypes.number.isRequired,
    energy: PropTypes.object,
    events: PropTypes.array,
    comments: PropTypes.array,
    speechHits: PropTypes.array,
    zoomed: PropTypes.bool,
    selectedEventType: PropTypes.string,
    showSpeechHits: PropTypes.bool,
    currentTime: PropTypes.number,
    areEventsRightAligned: PropTypes.bool,
    setTime: PropTypes.func,
  }

  static defaultProps = {
    energy: null,
    events: [],
    comments: [],
    speechHits: [],
    zoomed: false,
    selectedEventType: 'ALL',
    showSpeechHits: true,
    currentTime: 0,
    areEventsRightAligned: false,
    setTime: () => {},
  }

  static translateEnergy({ channel_0, channel_1 }, minmax) {
    const total = channel_0.length
    const translated = [...Array(total)]

    let translate
    if (!channel_1) {
      translate = (_, i) => ({
        index: i,
        channel_0: Math.min(Math.max(channel_0[i], -1 * minmax), minmax),
      })
    } else {
      translate = (_, i) => ({
        index: i,
        channel_0: Math.min(Math.max(channel_0[i], -1 * minmax), minmax),
        channel_1: Math.min(Math.max(channel_1[i], -1 * minmax), minmax),
      })
    }

    return translated.map(translate)
  }

  render() {
    const {
      theme,
      callDurationMs,
      audioDurationMs,
      audioOffsetMs,
      energy,
      events,
      comments,
      speechHits,
      selectedEventType,
      showSpeechHits,
      zoomed,
      currentTime,
      setTime,
      areEventsRightAligned,
    } = this.props

    const minmax = energy && energy.minmax ? energy.minmax : 0
    const chartData = energy ? AudioEnergy.translateEnergy(energy, minmax) : []

    const eventLanePadding = theme.spacing(2)
    const strokeWidth = 0.75

    return (
      <AutoSizer disableWidth>
        {({ height }) => {
          //If zoomed a pixel every 1/10th of a second
          const graphHeight = zoomed ? Math.max(callDurationMs / 100, height) : height
          const heightUnitsPerMs = graphHeight / callDurationMs
          const audioHeightPx = Math.max(Math.round(heightUnitsPerMs * audioDurationMs), 1) // prevent Victory console warning by having height of 1 if duration is 0
          const audioOffsetPx = Math.round(heightUnitsPerMs * audioOffsetMs)

          return (
            <div style={{ height: `${height}px`, width: theme.spacing(PANEL_SIZES.AUDIO) }}>
              <ConditionalWrap
                condition={zoomed}
                wrap={children => (
                  <PlayerPiano
                    duration={callDurationMs}
                    currentTime={currentTime}
                  >
                    {children}
                  </PlayerPiano>
                )}
              >
                <AudioEnergyTape
                  width={theme.spacing(PANEL_SIZES.AUDIO)}
                  graphHeight={graphHeight}
                  areEventsRightAligned={areEventsRightAligned}
                  eventLanePadding={eventLanePadding}
                  audioOffsetPx={audioOffsetPx}
                  audioOffsetMs={audioOffsetMs}
                  audioHeightPx={audioHeightPx}
                  heightUnitsPerMs={heightUnitsPerMs}
                  strokeWidth={strokeWidth}
                  chartData={chartData}
                  minmax={minmax}
                  energy={energy}
                  events={events}
                  comments={comments}
                  setTime={setTime}
                  speechHits={speechHits}
                  selectedEventType={selectedEventType}
                  showSpeechHits={showSpeechHits}
                />
              </ConditionalWrap>
            </div>
          )
        }}
      </AutoSizer>
    )
  }
}

export { AudioEnergy as UnstyledAudioEnergy }

export default withStyles({}, { withTheme: true })(AudioEnergy)
